import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const trainingError = (err, language) => {
  const d = err?.response?.data?.detail;
  return typeof d === 'string' ? d : d?.message || (language === 'IT' ? 'Operazione non riuscita' : 'Operation failed');
};

export const TrainingLinkPicker = ({ api, language, teamId, date, value, onChange, prefix, allowCreate = true, disabled = false }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const t = (it, en) => language === 'IT' ? it : en;
  const mode = value.training_link_mode || 'NONE';
  useEffect(() => {
    let alive = true;
    setOptions([]); setError('');
    if (mode !== 'LINK_EXISTING' || !teamId || !date) return;
    setLoading(true);
    api.get('/planner/training-sessions/eligible', { params: { team_id: teamId, date } })
      .then(r => { if (alive) setOptions(r.data); })
      .catch(e => { if (alive) setError(trainingError(e, language)); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [api, mode, teamId, date, language]);
  return <section className="space-y-3 min-w-0 border-y border-zinc-800 py-4" data-testid={`${prefix}-section`}>
    <Label className="text-emerald-300">{t('TRAINING nel Planner', 'Planner TRAINING')}</Label>
    <div className="flex flex-wrap gap-2">
      {[
        ['NONE', t('Indipendente', 'Independent')],
        ['LINK_EXISTING', t('Collega esistente', 'Link existing')],
        ...(allowCreate ? [['CREATE_NEW', t('Crea e collega', 'Create and link')]] : []),
      ].map(([id, label]) => <Button key={id} type="button" size="sm" variant={mode === id ? 'default' : 'outline'} disabled={disabled}
        aria-pressed={mode === id} data-testid={`${prefix}-mode-${id.toLowerCase()}`}
        onClick={() => onChange({ training_link_mode: id, training_planner_id: '' })}>{label}</Button>)}
    </div>
    {mode === 'LINK_EXISTING' && <div className="space-y-2">
      <Label htmlFor={`${prefix}-session`}>{t('Sessione nella stessa data', 'Session on the same date')}</Label>
      <select id={`${prefix}-session`} data-testid={`${prefix}-session`} disabled={disabled || loading}
        className="w-full min-w-0 rounded-md bg-zinc-950 border border-zinc-700 p-2 text-sm text-zinc-100"
        value={value.training_planner_id || ''} onChange={e => {
          const selected = options.find(s => s.id === e.target.value);
          onChange({ training_planner_id: e.target.value, training_selected_duration: selected?.duration_planned_min ?? null });
        }}>
        <option value="">{loading ? t('Caricamento…', 'Loading…') : t('Seleziona TRAINING', 'Select TRAINING')}</option>
        {options.map(s => <option key={s.id} value={s.id} data-testid={`${prefix}-option-${s.id}`}>{`${s.title} · ${s.duration_planned_min ?? '—'} min`}</option>)}
      </select>
      {!loading && !options.length && <p className="text-xs text-zinc-400" data-testid={`${prefix}-empty`}>{t('Nessuna sessione disponibile', 'No available sessions')}</p>}
    </div>}
    {mode === 'CREATE_NEW' && <div className="space-y-2">
      <Label htmlFor={`${prefix}-duration`}>{t('Durata Planner (min)', 'Planner duration (min)')}</Label>
      <Input id={`${prefix}-duration`} data-testid={`${prefix}-duration`} type="number" min="0" step="1" disabled={disabled}
        value={value.training_planner_duration ?? value.session_minutes ?? ''}
        onChange={e => onChange({ training_planner_duration: e.target.value })} />
    </div>}
    {error && <p role="alert" className="text-sm text-red-400" data-testid={`${prefix}-error`}>{error}</p>}
  </section>;
};